import { hasSignedUpFromWs } from '../../utils/web-helper';
import React from 'react';
import styled from 'styled-components';
import connect from '../../stores/parent-dashboard';
import { device } from '../../utils/responsive_utilities';
import { fontQuicksand } from './mixin';

function TrialInfo({settings}) {
  let { trialAvailable } = settings;
  const fromOnboarding = JSON.parse(localStorage.getItem('viaOnboarding'));
  return (
    <>
      <Heading>{ trialAvailable ? ((hasSignedUpFromWs() && fromOnboarding) ? 'Start your free trial to unlock unlimited worksheets' : `Start your ${settings.trailDays || 7}-day free trial`) : 'Subscribe To Unlock Unlimited Fun'}</Heading>
      <SubHeading>{trialAvailable ? `Get unlimited access for ${settings.trailDays || 7} days. Cancel anytime` : 'No Commitment. Cancel Anytime.'}</SubHeading>
    </>
  );
}

export const Heading = styled.div`
  ${fontQuicksand(3.2, 4, 7)}
  padding-top: 3.2rem;
  @media ${device.PhoneLargeScreen} {
    padding: 2rem 2rem 1rem;
    ${fontQuicksand(2.4, 3, 7)}
  }
  @media ${device.Phone} {
    padding: 3rem 2rem 1rem;
    ${fontQuicksand(2, 2.6, 7)}
  }
`;

export const SubHeading = styled.div`
${fontQuicksand(1.4, 1.8, 7)}
  font: normal bold 1.4rem/1.6rem Quicksand;
  margin: 1rem 0;
  @media ${device.PhoneLargeScreen} {
    ${fontQuicksand(1.2, 1.6, 7)}
    padding-bottom: 1rem;
  }
  @media ${device.Phone} {
    ${fontQuicksand(1.2, 1.6, 7)}
    padding-bottom: 1rem;
  }
`

export default connect(null, null, TrialInfo)